<div class="project-quick-create-dialog" data-cy="project-quick-create-dialog">
  <div class="detail-card-header p--12">
    <div class="flex--r-c flex--wrap gap--12">
      <i class="workheld-icons" [innerHtml]="projectIcon"></i>
      {{ 'nav.work.quickcreateproject' | translate }}
    </div>
  </div>

  <mat-dialog-content>
    <form [formGroup]="form" class="flex--col gap--8">
      <div class="flex--row gap--8">
        <!-- Project ID -->
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>{{ "project.model.extid" | translate }}</mat-label>
          <input matInput formControlName="extId" autocomplete="off" data-cy="project-extId" />
        </mat-form-field>

        <!-- Title (required) -->
        <mat-form-field appearance="outline" class="flex-2">
          <mat-label>{{ "project.model.title" | translate }}</mat-label>
          <input
            matInput
            formControlName="title"
            required
            autocomplete="off"
            data-cy="project-title"
          />
        </mat-form-field>
      </div>

      <!-- Customer & Equipment -->
      <div class="flex--row gap--8">
        <w-h-autocomplete-scroll class="flex-1"
          data-cy="project-customer"
          [data$]="customerData$"
          [loading$]="customersLoading$"
          [labelKey]="'customer.model.root'"
          [initialValue]="customerInitialValue()"
          [clearSelected]="clearAutocompletes()"
          (onItemSelect)="onCustomerSelect($event)"
          (onScrollEvent)="loadCustomers($event)"
        ></w-h-autocomplete-scroll>

        <w-h-autocomplete-scroll class="flex-1"
          data-cy="project-equipment"
          [data$]="equipmentData$"
          [loading$]="equipmentLoading$"
          [labelKey]="'nav.equipment.root'"
          [imageUrlKey]="'thumbnailURL'"
          [subItemStrings]="['equipmentNumber', 'customerName']"
          [fallbackImage]="'EQUIPMENT'"
          [clearSelected]="clearAutocompletes()"
          [clearEvent]="clearEquipment$"
          (onItemSelect)="onEquipmentSelect($event)"
          (onScrollEvent)="loadEquipments($event)"
        ></w-h-autocomplete-scroll>
      </div>

      <!-- Team -->
      <lib-w-h-dropdown
        [required]="false"
        [valueLabel]="'app.team.label'"
        [itemKeys]="['name']"
        [subItemKey]="'top'"
        [valueFormControl]="teamNameFormControl"
        [dropdownItemDomList]="teamDropdownItemDomList"
        [loading]="teamDropdownLoading"
        (onDomEvent)="onTeamEvent($event)"
      ></lib-w-h-dropdown>

      <!-- Category & Target State -->
      <div class="flex--row gap--8">
        <lib-w-h-dropdown class="flex-1"
          [required]="false"
          [valueLabel]="'project.model.category'"
          [itemKeys]="['translateKey']"
          [value]="'id'"
          [valueFormControl]="form.controls.category"
          [dropdownItemDomList]="ENUMS.WORK_OBJECT_CATEGORY | whenum"
        ></lib-w-h-dropdown>

        <lib-w-h-dropdown class="flex-1"
          [required]="false"
          [valueLabel]="'ui.model.targetState'"
          [itemKeys]="['translateKey']"
          [value]="'id'"
          [valueFormControl]="form.controls.targetState"
          [dropdownItemDomList]="ENUMS.WORK_OBJECT_TARGET_STATE | whenum"
        ></lib-w-h-dropdown>
      </div>

      <!-- Start / End Date -->
      <lib-w-h-datetime-picker
        [parentFormGroup]="dateFormGroup"
        startDateForm="startDateForm"
        endDateForm="endDateForm"
        [hasEndDate]="true"
        [futureDate]="true"
        [startDateLabel]="'project.model.start'"
        [endDateLabel]="'project.model.end'"
      ></lib-w-h-datetime-picker>

      <!-- Description -->
      <mat-form-field appearance="outline">
        <mat-label>{{
          "workobject.model.description" | translate
        }}</mat-label>
        <textarea
          matInput
          formControlName="description"
          rows="3"
        ></textarea>
      </mat-form-field>

      <!-- Location -->
      @if (isLocationEnabled()) {
        <ng-bee-w-h-agm-core-location-form [locationFormGroup]="locationFormGroup">
        </ng-bee-w-h-agm-core-location-form>
      }

      <!-- Work Order Section -->
      <h4 class="section-header">
        {{ "workorder.model.root" | translate }}
      </h4>

      <div class="flex--row gap--8">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>{{ "workorder.model.extid" | translate }}</mat-label>
          <input matInput formControlName="workOrderExtId" autocomplete="off" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-2">
          <mat-label>{{ "workorder.model.title" | translate }}</mat-label>
          <input
            matInput
            formControlName="workOrderTitle"
            autocomplete="off"
          />
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>{{
          "workorder.model.description" | translate
        }}</mat-label>
        <textarea
          matInput
          formControlName="workOrderDescription"
          rows="2"
        ></textarea>
      </mat-form-field>

      <lib-w-h-dropdown
        [required]="false"
        [valueLabel]="'workorder.model.category'"
        [itemKeys]="['translateKey']"
        [value]="'id'"
        [valueFormControl]="form.controls.workOrderCategory"
        [dropdownItemDomList]="ENUMS.CATEGORY | whenum"
      ></lib-w-h-dropdown>

      <!-- Work Step Section -->
      <h4 class="section-header">
        {{ "workstep.model.root" | translate }}
      </h4>

      <div class="flex--row gap--8">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>{{ "workstep.model.extid" | translate }}</mat-label>
          <input matInput formControlName="workStepExtId" autocomplete="off" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-2">
          <mat-label>{{ "workstep.model.title" | translate }}</mat-label>
          <input
            matInput
            formControlName="workStepTitle"
            autocomplete="off"
          />
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>{{
          "workstep.model.description" | translate
        }}</mat-label>
        <textarea
          matInput
          formControlName="workStepDescription"
          rows="2"
        ></textarea>
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <div class="dialog-actions" mat-dialog-actions>
    <mat-checkbox
      [checked]="createAnother()"
      (change)="createAnother.set($event.checked)"
    >
      {{ 'modal.toggle.createanother' | translate }}
    </mat-checkbox>
    <w-h-button-group align="end">
      <w-h-button
        data-cy="project-cancel"
        [text]="'app.cancel.label' | translate | uppercase"
        matIcon="close"
        type="stroked"
        [disabled]="saving()"
        (clicked)="cancel()"
      />
      <w-h-button
        data-cy="project-save"
        [text]="'app.save.label' | translate | uppercase"
        matIcon="save"
        [isLoading]="saving()"
        color="accent"
        type="flat"
        [disabled]="form.invalid"
        (clicked)="submit()"
      />
    </w-h-button-group>
  </div>
</div>
